import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Popconfirm,
  message,
  Modal,
  Switch,
  Tooltip,
} from "antd";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { API_LIST_STORE, API_DELETE_STORE } from "api/store-managemnt"; // Import your API functions
import EditStore from "views/admin/storeManagement/EditStore";
import ViewStore from "views/admin/storeManagement/ViewStore/ViewStore";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API_LIST_LAUNDRY_BOX } from "api/laundrybox-management";
import { API_DELETE_LAUNDRY_BOX } from "api/laundrybox-management";
import ViewLaundryBox from "views/admin/laundryBoxmanagement/ViewLaundryBox/ViewLaundryBox";
import EditLaundryBox from "views/admin/laundryBoxmanagement/EditLaundryBox";
import { API_ENABLE_DISABLE_LAUNDRY_BOX } from "api/laundrybox-management";
const { Column } = Table;
const { TextArea } = Input;
const LaundryBoxTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 }); // Initial pagination settings
  const [searchName, setSearchName] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        name: searchName,
      };
      const newData = await API_LIST_LAUNDRY_BOX(params);
      console.log("provider", newData);
      setData(newData);
      setLoading(false);
      setPagination({ ...pagination, total: newData.total_boxes }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, searchName]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleSearch = (value) => {
    setSearchName(value);
  };

  const handleEdit = (record) => {
    setSelectedStore(record);
    setEditModalVisible(true);
    navigate(`/admin/laundry-box/edit/${record._id}`, {
      state: { data: record },
    });
  };

  const handleView = (record) => {
    setSelectedStore(record);
    setViewModalVisible(true);
    navigate(`/admin/laundry-box/${record._id}`, {
      state: { data: record },
    });
  };

  const handleDelete = async (id) => {
    try {
      await API_DELETE_LAUNDRY_BOX(id);
      message.success("Laundry box deleted successfully");
      fetchData(); // Refresh data after delete
    } catch (error) {
      console.error("Error deleting :", error);
      message.error("Failed to delete");
    }
  };

  const handleEditModalOk = () => {
    // Implement edit store logic here
    console.log("Editing store:", selectedStore);
    setEditModalVisible(false);
  };

  const handleViewModalOk = () => {
    // Implement view store logic here
    console.log("Viewing store:", selectedStore);
    setViewModalVisible(false);
  };

  const handleModalCancel = () => {
    setEditModalVisible(false);
    setViewModalVisible(false);
  };
  const handleSwitchChange = async (checked, record) => {
    try {
      const response = await API_ENABLE_DISABLE_LAUNDRY_BOX(record._id); // Assuming API_ENABLE_DISABLE_DRIVER accepts driver ID and status as parameters
      message.success(response?.message);
      fetchData(); // Refresh data after delete
    } catch (error) {
      console.error("Error toggling driver status:", error);
      message.error(error?.response?.data?.error || "Failed to toggle  status");
    }
  };
  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };
  return (
    <div>
      <div className=" mb-4 flex justify-between">
        <Input
          className="border-none"
          placeholder={t("Search by name")}
          prefix={<SearchOutlined />}
          allowClear
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 200 }}
        />

        {process.env.REACT_APP_APPLICATION_NAME === "laundry" && (
          <Link
            to={"/admin/laundry-box/create-laundry-box"}
            className="linear p-[4px 11px] flex w-full max-w-[11rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-base font-medium text-white transition duration-200 hover:bg-white hover:text-brand-500 dark:bg-brand-400 dark:text-white  dark:active:bg-brand-200"
          >
            + {t("Create Laundry Box")}
          </Link>
        )}
      </div>
      <Table
        dataSource={data?.laundry_boxes}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey={(record) => record.id} // Assuming each record has a unique id
        rowClassName={getRowClassName} // Apply alternating row colors
        scroll={{ x: true }}
      >

        <Column title={t("Name")} dataIndex="name" key="name" width={"9rem"} />
        <Column
          title={t("Description")}
          dataIndex="description"
          key="description"
          width="9rem"
          render={(text) => (
            <Tooltip title={text}>
              {text.length > 20 ? `${text.substring(0, 20)}...` : text}
            </Tooltip>
          )}
        />

        <Column
          title={t("Maximum Item Capacity")}
          dataIndex="max_item_capacity"
          key="max_item_capacity"
          width="9rem"
        />
        <Column
          title={t("Location")}
          dataIndex="location"
          key="location"
          // render={(text, record) => (
          //   <span>{record?.location_details?.address}</span>
          // )}
          render={(text, record) => (
            <Tooltip title={record?.location_details?.address}>
              {record?.location_details?.address?.length > 20
                ? `${record?.location_details?.address?.substring(0, 20)}...`
                : record?.location_details?.address}
            </Tooltip>
          )}
          width="9rem"
        />
        <Column
          title={t("Status")}
          dataIndex="is_disable"
          key="is_disable"
          width="9rem"
          render={(text, record) => (
            <Switch
              checked={!record.is_disable}
              onChange={(checked) => handleSwitchChange(checked, record)}
            />
          )}
        />

        {/* <Column
          title="Select Laundry"
          dataIndex="laundry"
          key="laundry"
          render={(text, record) => <span>{record?.laundry?.[0]}</span>}
        /> */}
        <Column
          title={t("Actions")}
          key="actions"
          width="9rem"
          render={(text, record) => (
            <div>
              {process.env.REACT_APP_APPLICATION_NAME === "laundry" && (
                <Button
                  type="primary"
                  icon={<EditOutlined />}
                  onClick={() => handleEdit(record)}
                ></Button>
              )}
              {process.env.REACT_APP_APPLICATION_NAME === "laundry" && (
                <Popconfirm
                  title={t("Are you sure to delete this Laundry box?")}
                  onConfirm={() => handleDelete(record?._id)}
                  okText={t("Yes")}
                  cancelText={t("No")}
                >
                  <Button
                    type="danger"
                    icon={<DeleteOutlined />}
                    style={{ border: "1px solid #d9d9d9", marginLeft: "5px" }}
                  ></Button>
                </Popconfirm>
              )}
              <Button
                type="default"
                icon={<EyeOutlined />}
                onClick={() => handleView(record)}
                style={{ marginLeft: "5px" }}
              ></Button>
            </div>
          )}
        />
      </Table>

      {/* Edit Store Modal */}
      <Modal
        key={selectedStore?._id}
        // title={t("Edit Store")}
        visible={editModalVisible}
        onOk={handleEditModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "65rem" }}
      >
        <EditLaundryBox data={selectedStore} />
      </Modal>

      {/* View Store Modal */}
      <Modal
        key={selectedStore?._id}
        // title={t("View Store")}
        visible={viewModalVisible}
        onOk={handleViewModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "60rem" }}
      >
        <ViewLaundryBox data={selectedStore} />
      </Modal>
    </div>
  );
};

export default LaundryBoxTable;
